<template>
  <div class="header">
    <div class="weather">
      <div>{{ this.environment.Type }}</div>
      <span
        >温度:{{ this.environment.temperatureMin }}-
        {{ this.environment.temperatureMax }}</span
      >
      <span>{{ this.environment.air }}</span>
    </div>
    <div class="header-font">
      <span>木棉树仪表远程运维和智能分析平台</span>
    </div>
    <div class="time">
      <span>{{ nowDate }}</span>
      <span>{{ nowWeek }}</span>
      <span>{{ nowTime }}</span>
    </div>
  </div>
</template>

<script>
//import { getAmbientWeather } from "../api/api";
export default {
  name: "HelloWorld",
  data() {
    return {
      environment: "", //环境天气
      timer: null,
      nowWeek: "", //时间
      nowDate: "",
      nowTime: "",
    };
  },
  props: {},
  created() {
    //环境天气
//  getAmbientWeather().then((res) => {
//       console.log( res.data, "环境天气");
      this.environment =  {
    "Type": "晴",
    "temperatureMax": "30°",
    "temperatureMin": "16°",
    "air": "75良"
};
//  });
  },
  mounted() {
    // 实时时间
    this.timer = setInterval(() => {
      this.setNowTimes();
    }, 1000);
  },
  methods: {
    //实时时间
    setNowTimes() {
      let myDate = new Date();
      // console.log(myDate)
      let wk = myDate.getDay();
      let yy = String(myDate.getFullYear());
      let mm = String(
        // myDate.getMonth() + 1
        myDate.getMonth() + 1 < 10
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1
      );
      let dd = String(
        myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate()
      );
      let hou = String(
        myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours()
      );
      let min = String(
        myDate.getMinutes() < 10
          ? "0" + myDate.getMinutes()
          : myDate.getMinutes()
      );
      let sec = String(
        myDate.getSeconds() < 10
          ? "0" + myDate.getSeconds()
          : myDate.getSeconds()
      );
      let weeks = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      let week = weeks[wk];
      this.nowDate = yy + "/" + mm + "/" + dd;
      this.nowTime = hou + ":" + min + ":" + sec;
      this.nowWeek = week;
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 9vh;
  background: url("../assets/img/header.png") no-repeat;
  background-size: 100% auto;
  background-position: center center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1;
  color: white;
  position: absolute;
}

.header .header-font {
  width: 43.2vw;
  height: 100%;
}

.header-font span {
  color: white;
  font-size: 1.875vw;
  line-height: 5.8vh;
  height: 2.5vh;
  /* text-shadow: .5px .5px white; */
  font-family: pangmenzhengdao;
}

.header .weather {
  width: 15.625vw;
  height: 4.9vh;
  display: flex;
  justify-content: space-between;
  font-size: 0.6vw;
  font-family: SIMHEI;
}

.header .weather div {
  width: 3vw;
  height: 2.2vh;
  text-indent: 0.7vw;
  background: url("../assets/img/sun.png") no-repeat;
  margin-left: 1.14vw;
  line-height: 2.4vh;
}

.header .weather span {
  width: 5.8vw;
  height: 2.2vh;
  line-height: 2.4vh;
}

.header .weather span:nth-child(2) {
  margin-right: 1vw;
}
.header .weather span:nth-child(3) {
  width: 2.44vw;
  background: #0c5b70;
  border-radius: 0.7vw;
  margin-right: 2vw;
}

.header .time {
  width: 15.625vw;
  height: 4.9vh;
  display: flex;
  font-size: 0.6vw;
  line-height: 2.4vh;
  justify-content: space-around;
  font-family: SIMHEI;
}

.header .time span:nth-child(1) {
  margin-left: 1.3vw;
}
</style>
